import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UiPopup } from "./UiModal";
import { SomethingWrongModal } from "../Popups/SomethingWrongModal";
import { ConfirmationIcon } from "../../../styles/img/svg/ConfirmationIcon";
import { clearReducer, hideError } from "../../../_redux/_actions";
import { responseCodes } from "../../../_redux/_constants";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import UiCustomErrors from "./UiCustomErrors";
import { RedWarningIcon } from "../../../styles/img/svg/RedWarningIcon";
import { removeUserDetails } from "../../../_helpers/auth.helper";

const UiAlert = (props) => {
  const { t, i18n } = useTranslation();
  const actionDispatch = useDispatch();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState();
  const [subMessage, setSubMessage] = useState("");
  const [showAssistance, setShowAssistance] = useState(false);
  const [showLocked, setShowLocked] = useState(false);
  const [isTitleColor, setIsTitleColor] = useState(false);
  const [showNoFdCasa, setShowNofdCasa] = useState(false);
  const { errorMessage } = useSelector((state) => {
    return {
      errorMessage: state.errorMessage,
    };
  });

  const [isTimerFalse, setIsTimerFalse] = useState(false);

  const [isTransAvailable, setIsTransAvailable] = useState(false);
  const [modalState, setModalState] = useState();

  useEffect(() => {
    const statusCode = errorMessage?.statusCodes?.[0];
    const firstMessage = errorMessage?.messages?.[0] || ""; //?.trim()

    switch (statusCode) {
      case responseCodes.STATEMENT_DOWNLOAD_EMPTY_RECORDS:
        setTitle(t("Uh-oh!"));
        setMessage(
          t(
            "No transaction available for the selected account and date range.",
          ),
        );
        setShowAssistance(true);
        break;

      case responseCodes.OB_ACCOUNT_LOCKED:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Locked"));
        setMessage(
          t(
            "We have temporarily locked your LOLC account due to multiple incorrect attempts.\n\nYour lock will be lifted in;",
          ),
        );
        setSubMessage(firstMessage);
        setShowAssistance(false);
        break;

      case responseCodes.ONBOARDING_ACCOUNT_BLOCKED:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Temporarily Locked"));
        setMessage(
          t(
            "We have temporarily locked your LOLC account due to multiple incorrect attempts.\n\nYour lock will be lifted in;",
          ),
        );
        setSubMessage(firstMessage);
        setShowAssistance(false);
        break;

      case responseCodes.AUTH_ERROR_CUSTOMER_TEMPORARILY_BLOCKED_BY_WRONG_OTP:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Locked"));
        setMessage(
          t(
            "We have temporarily locked your LOLC account due to multiple incorrect attempts.\n\nYour lock will be lifted in;",
          ),
        );
        setSubMessage(firstMessage);
        setShowAssistance(false);

        break;

      case responseCodes.OTP_BLOCKED:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Locked"));
        setShowAssistance(false);
        setMessage(
          t(
            "We have temporarily locked your LOLC Online Banking account due to multiple incorrect attempts.\n\nYour lock will be lifted in;",
          ),
        );
        setSubMessage(firstMessage);
        setShowAssistance(false);
        break;

      case responseCodes.APPLICATION_SETTING_PW_CHANGE_TEMP_ACC_LOCKED:
        setShowLocked(true);
        setTitle(t("Account Locked"));
        setIsTitleColor(true);
        setMessage(
          t(
            "We have temporarily locked your LOLC account due to multiple incorrect attempts.\n\nYour lock will be lifted in;",
          ),
        );
        setSubMessage(firstMessage);
        setShowAssistance(false);
        break;

      case responseCodes.ADMIN_PASSWORD_EXPIRED_CODE:
        setTitle(t("Temporary password has expired"));
        setMessage(
          t(
            "The entered password has expired. Kindly reach out to the bank for further assistance.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.OB_ACCOUNT_BLOCKED:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Blocked"));
        setMessage(firstMessage);
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.CANNOT_VALIDATE_BILLER_TYPE_CODE:
        setTitle(t("Invalid Biller Account Number"));
        setSubMessage("");
        setMessage(
          t(
            "The biller account number you entered is invalid. Please double-check the number and try again.",
          ),
        );
        setShowAssistance(false);
        break;
      case responseCodes.MINIMUM_AMOUNT_ERROR_CODE:
        setTitle(t("Uh-oh!"));
        setMessage(
          t("The amount you entered is below the minimum transaction amount."),
        );
        setSubMessage("");
        setShowAssistance(false);
        break;

      case responseCodes.MAXIMUM_AMOUNT_ERROR_CODE:
        setTitle(t("Uh-oh!"));
        setMessage(
          t("The amount you entered exceeds the maximum transaction amount."),
        );
        setSubMessage("");
        setShowAssistance(false);
        break;

      case responseCodes.OB_PROFILE_NOT_FOUND:
        setTitle(t("Online Banking Profile Not Found"));
        setMessage(
          t(
            'You cannot use the "Forgot Login Details" option as you have not logged into LOLC Online Banking yet. Please sign in for the first time to create your Internet Banking profile.',
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.CBS_DOWN_ERROR_CODE:
        setTitle(t("Uh-oh! Something went wrong"));
        setIsTransAvailable(true);
        setMessage(
          t("We encountered an issue on our end. Please try again later."),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;
      case responseCodes.SYSTEM_ERROR:
        setIsTransAvailable(true);
        setTitle(t("Uh-oh! Something went wrong"));
        setIsTransAvailable(true);
        setMessage(
          t("We encountered an issue on our end. Please try again later."),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.APPLICATION_SETTING_PW_CHANGE_INCORRECT_PW_ATTEMPT:
      case responseCodes.SETTING_AUTH_ERROR_PASSWORD_INCORRECT:
        setTitle(t("Password Incorrect"));
        setMessage(
          t(
            "It seems like the password you provided is incorrect. Please double-check your credentials and try again.",
          ),
        );
        setSubMessage(firstMessage);
        setShowAssistance(true);
        break;

      case responseCodes.AUTH_ERROR_PASSWORD_EXPIRED_SET_PASSWORD_ERROR:
        setTitle(t("Invalid Password"));
        setMessage(firstMessage);
        setSubMessage("");
        setShowAssistance(false);
        break;

      case responseCodes.FORGOT_USERNAME_NIC_PASSPORT_ERR0R_CODE:
      case responseCodes.INVALID_ACCOUNT:
      case responseCodes.INVALID_ACCOUNT_TYPE_SELECTION:
        setTitle(t("Invalid Account Details"));
        setMessage(t("It seems the bank account number is not eligible to continue this process."));
        setShowAssistance(true);
        break;

      case responseCodes.INVALID_DATE_OF_BIRTH:
        setTitle(t("Invalid Account Details"));
        setMessage(t("The Account Number, Date of Birth and NIC number combination does not match our records. Please review your information and try again."));
        setShowAssistance(true);
        break;

      case responseCodes.INVALID_CREDIT_CARD_NUMBER:
        setTitle(t("Incorrect Credit Card Details"));
        setMessage(
          t(
            "It seems like the entered credit card details are incorrect. Please double-check and try again.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;
      case responseCodes.ADMIN_PASSWORD_RESET_CODE:
        setTitle(t("Temporary password Sent"));
        setMessage(
          t(
            "It seems the bank has already sent you a temporary password. Please use it to log in and reset your password.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;
      case responseCodes.FORGOT_PASSWORD_NIC_ERROR_CODE:
        setTitle(t("Invalid Details"));
        setMessage(
          t(
            "The username and NIC number combination you have provided does not match. Please double-check and try again.",
          ),
        );
        setShowAssistance(true);
        break;
      case responseCodes.ADMIN_BLOCKED_ACCOUNT_CODE:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Inactive"));
        setMessage(t("It seems like your LOLC account is not active."));
        setSubMessage("");
        setShowAssistance(true);
        break;
      case responseCodes.OB_BLOCKED_ACCOUNT_CODE:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Inactive"));
        setMessage(
          t("It seems like your LOLC Online Banking account is not active."),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;
      case responseCodes.BILLER_INACTIVE_CODE:
        setTitle(t("Biller Inactive"));
        setMessage(
          t(
            "This biller is currently inactive and cannot accept payments. Please choose a different biller.",
          ),
        );
        setShowAssistance(true);
        break;
      case responseCodes.FUND_TRANFER_INSUFFICIENT_FUNDS_ERROR_CODE:
        setIsTransAvailable(true);
        setShowAssistance(false);
        setTitle(t("Insufficient Funds"));
        setMessage(
          "The selected payment method has insufficient funds. Please choose a different payment method or add funds to proceed.",
        );
        setSubMessage("");

        break;

      case responseCodes.INVALID_FUND_TRANSFER_ACCOUNT_NUMBER:
        setTitle(t("Invalid Account Number"));
        setIsTransAvailable(true);
        setMessage(
          t(
            "It seems like the entered bank account number is invalid.Please check the number and try again.",
          ),
        );
        setSubMessage("");
        setShowAssistance(false);
        break;

      case responseCodes.FUND_TRANSFER_OWN_ACCOUNT_ERROR_CODE:
        setTitle(t("Transfer Not Allowed"));

        setMessage(
          t(
            "You cannot transfer to your own LOLC account using this option. Please use the 'Own Account' transfer option instead.",
          ),
        );
        setSubMessage("");
        setShowAssistance(false);
        break;
      case responseCodes.AUTH_ERROR_ADMIN_ACCOUNT_BLOCK:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Blocked"));
        setMessage(
          t("It seems like your LOLC account has been blocked by the bank."),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.AUTH_ERROR_ACCOUNT_BLOCK:
        setShowLocked(true);
        setIsTitleColor(true);
        setTitle(t("Account Blocked"));
        setMessage(
          t(
            "It seems like your LOLC Online Banking account has blocked by the bank.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;
      case responseCodes.FD_OPENING_CUSTOMER_NOT_ELIGIBLE_CASA_ACCOUNT:
        setIsTimerFalse(true);
        setTitle(t("Unable to Open Fixed Deposit"));
        setMessage(
          t("You do not have an eligible account to open a fixed deposit."),
        );
        setSubMessage(
          t(
            "Please check your Account Preferences settings or open an eligible account to proceed.",
          ),
        );
        setShowAssistance(true);
        break;

      case responseCodes.SAVING_ACCOUNT_OPENING_NOT_ELIGIBLE_CASA_ACCOUNT:
        setIsTimerFalse(true);

        setTitle(t("Unable to Open a Savings Account"));
        setMessage(
          t("You do not have an eligible account to open a savings account."),
        );
        setSubMessage(
          t(
            "Please check your Account Preferences settings or open an eligible account to proceed.",
          ),
        );
        setShowAssistance(true);
        break;

      case responseCodes.NOT_ELIGIBLE_FOR_ONBOARDING:
        setShowLocked(true);
        setTitle(t("We have encountered a problem in your LOLC profile"));
        setMessage(
          t(
            "It looks like the identification number provided isn't eligible for Digital Banking services.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.ACCOUNT_NO_CAN_NOT_BE_USED_FOR_REGISTERING:
        setTitle(t("Invalid Account Details"));
        setMessage(
          t(
            "It seems like the bank account number is not eligible to register for Digital Banking services.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.NO_CONTACT_INFORMATION_ONBOARDING:
        setTitle(t("We have encountered a problem in your LOLC profile"));

        setMessage(
          t(
            "Please ensure your mobile number or email address is registered with your LOLC bank profile to proceed with LOLC registration.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);

        break;

      case responseCodes.INVALID_CREDIT_CARD_DETAILS:
        setTitle(t("Incorrect Credit Card Details"));
        setMessage(
          t(
            "It seems like the entered credit card number is not eligible to register for Digital Banking services.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.CUSTOMER_ONBOARDING_EMAIL_PHONE_ALREADY_EXISTS:
        setTitle(t("We have encountered a problem in your LOLC profile"));
        setMessage(
          t(
            "Please ensure your mobile number or email address is registered with your LOLC bank profile to proceed with LOLC registration.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);

        break;

      case responseCodes.CUSTOMER_ONBOARDING_NOT_ELIGIBLE:
        setTitle(t("Incorrect Credit Card Details"));
        setMessage(
          t(
            "It seems like the entered credit card number is not eligible to register for Digital Banking services.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.FORGOT_PASSPORT_ERR0R_CODE:
        setTitle(t("Incorrect Details"));
        setMessage(
          t(
            "The details you provided do not match. Please check your details and try again.",
          ),
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.AUTH_ERROR_DIFFERENT_DEVICE_LOGIN:
        setTitle(t("Security Alert"));
        setIsTransAvailable(true);
        setMessage(
          "We noticed someone else signed in to your account from another device, so we logged you out to be safe.Log in again if it wasn’t you.",
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.AUTH_ERROR_SERVICE_SESSION_INVALID:
      case responseCodes.AUTH_ERROR_SERVICE_SESSION_TIME_OUT:
      case responseCodes.SESSION_TIME_OUT_SERVICE_ERROR_CODE:
        setTitle(t("Security Alert"));
        setIsTransAvailable(true);
        setMessage(
          "Looks like your session has timed out. Please log in to your LOLC account again to continue.",
        );
        setSubMessage("");
        setShowAssistance(true);
        break;

      case responseCodes.NOTIFICATION_NOT_AVAILABLE:
        setTitle(t("Notification Unavailable"));
        setIsTransAvailable(true);
        setMessage(
          t("The notification you’re trying to access is no longer available."),
        );
        break;

      default:
        setTitle(t("Uh-oh!"));
        setMessage(
          firstMessage ||
            t("We encountered an issue on our end. Please try again later."),
        );
        setSubMessage("");
        setShowAssistance(false);
        break;
    }

    setModalState(errorMessage?.show);
  }, [errorMessage?.show]);

  const hideAlert = () => {
    actionDispatch(hideError());

    if (
      errorMessage.statusCodes.includes(
        responseCodes.EXISTING_USER_ON_BOARDING_INPROGRESS,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_ACCOUNT_NOT_ACTIVE,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_DIFFERENT_DEVICE_LOGIN,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_SERVICE_SESSION_TIME_OUT,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_SESSION_TIME_OUT,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.IDLE_TIMEOUT_LOGOUT_CODE,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_SERVICE_SESSION_INVALID,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_ACCOUNT_BLOCK_OTP,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_TEMP_BLOCK,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_ADMIN_BLOCK,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_OTP_CONFIRM_INCORRECT_ACCOUNT_BLOCK,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_BLOCK,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_FORGOT_PASSWORD_DO_NOT_HAVE_CARD,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_PASSCODE_OTP_CONFIRM_INCORRECT_ACCOUNT_BLOCK,
      ) ||
      // errorMessage.statusCodes.includes(
      //   responseCodes.AUTH_ERROR_ACCOUNT_BLOCK,
      // ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_DL_ACCOUNT_BLOCK,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_INTERNET_BANKING_BLOCKED,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.AUTH_ERROR_IB_ACCOUNT_BLOCK_ADMIN,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.INWARD_OUTWARD_CHEQUE_STATUS_FAIL_CODE,
      ) ||
      errorMessage.statusCodes.includes(responseCodes.OB_ACCOUNT_LOCKED) ||
      errorMessage.statusCodes.includes(
        responseCodes.APPLICATION_SETTING_PW_CHANGE_TEMP_ACC_LOCKED,
      ) ||
      // errorMessage.statusCodes.includes(
      //   responseCodes.AUTH_ERROR_ADMIN_ACCOUNT_BLOCK,
      // ) ||
      errorMessage.statusCodes.includes(
        responseCodes.ONBOARDING_ACCOUNT_BLOCKED,
      ) ||
      errorMessage.statusCodes.includes(
        responseCodes.SESSION_TIME_OUT_SERVICE_ERROR_CODE,
      ) ||
      errorMessage.statusCodes.includes(responseCodes.OTP_BLOCKED)
      // ||
      // errorMessage.statusCodes.includes(
      //     responseCodes.AUTH_ERROR_CUSTOMER_ONBOARD_PASSCODE_ALREADY_REGISTERED,
      // )
    ) {
      actionDispatch(clearReducer());
      removeUserDetails();
      navigate("/");
    }

    // TODO need to check this once CBS is down
    if (errorMessage.statusCodes.includes(responseCodes.CBS_DOWN_ERROR_CODE)) {
      navigate("/app/dashboard");
    }
    setShowLocked(false);
  };

  const handleEligibleCasaClick = () => {
    actionDispatch(hideError());
    setShowNofdCasa(false);
  };

  return (
    <>
      {errorMessage?.show && !showLocked ? (
        <UiPopup openModal={() => {}} handleClose={hideAlert}>
          <SomethingWrongModal
            icon={<ConfirmationIcon />}
            message={title}
            isTransAvailable={isTransAvailable}
            buttonText={t("Ok")}
            buttonOnClick={hideAlert}
            className="df-confirmation-message-popup df-btn-grpdmodal"
            buttonClass="df-ui-dark-bg-btn df-w-90-btn"
          >
            <p>
              {isTransAvailable ? <Trans i18nKey={message} /> : <>{message}</>}
              {subMessage ? (
                <>
                  <br /> <br />
                  <span
                    className={`${!isTimerFalse && "df-modal-timer"}  mb-1`}
                  >
                    {subMessage}
                  </span>
                </>
              ) : null}
            </p>
            {showAssistance ? (
              <>
                <p className="mb-0 mt-1">{t("contactSupportText")}</p>
                <a
                  href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
                  className="df-primary-underlined-btn  mt-0 mb-0 df-link-color"
                >
                  {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
                </a>
              </>
            ) : (
              <br />
            )}
          </SomethingWrongModal>
        </UiPopup>
      ) : !errorMessage?.show &&
        errorMessage?.customErrors?.length > 0 &&
        !showLocked ? (
        <UiCustomErrors customError={errorMessage.customErrors[0]} />
      ) : null}

      {showLocked ? (
        <UiPopup openModal={() => {}} handleClose={hideAlert}>
          <SomethingWrongModal
            icon={<RedWarningIcon />}
            message={t(title)}
            buttonText={t("Ok")}
            buttonOnClick={hideAlert}
            className={`df-confirmation-message-popup df-btn-grpdmodal ${
              isTitleColor ? "df-acc-locked-mdl" : ""
            }`}
            buttonClass="df-ui-dark-bg-btn df-w-90-btn"
          >
            <p>
              {message &&
                message.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
            </p>
            {subMessage ? (
              <>
                <br />
                <span className={`${!isTimerFalse && "df-modal-timer"}  mb-1`}>
                  {subMessage}
                </span>
              </>
            ) : null}
            <p className="mb-0 mt-1">{t("contactSupportText")} </p>
            <a
              href={`tel:${process.env.SUPPORT_CENTER_CONTACT_NUMBER}`}
              className="df-primary-underlined-btn  mt-0 mb-0 df-link-color"
            >
              {process.env.SUPPORT_CENTER_CONTACT_NUMBER_LABEL}
            </a>
          </SomethingWrongModal>
        </UiPopup>
      ) : null}
    </>
  );
};

export default UiAlert;
